export enum Permission {
    Dev = 0,

    Usuario = 1,
    UsuarioOperar = 2,

    Caixa = 3,

    FaturaReabrir = 4,
    FaturaCancelar = 5,
    FaturaDesfazerCancelamento = 11,

    Despesa = 6,
    DespesaOperar = 7,

    ClienteEditarRemetente = 8,

    CaixaPesquisar = 12,
}